export const dbTabs2 = {
  ageRules: {
    heading: "Regole per gli ospiti",
    headHint:
      "Definisci chi viene considerato neonato, bambino o adulto e come incide sulla capacità {scope}. Per impostazione predefinita, i neonati non occupano un posto e non comportano alcun addebito.",
    scopeHotel: "di ogni camera",
    scopeApartment: "dell'alloggio",
    loading: "Caricamento regole…",
    emptyHotel: "Questo hotel non ha camere configurate.",
    capacityChipTitle: "Capacità della camera (impostata in Capacità)",
    slots: "{count} posto | {count} posti",
    badgeCustom: "Personalizzato",
    badgeStandard: "Standard",
    applyAgeRules: "Applica le regole per età",
    masterSubHotel: "Neonati, bambini e capacità personalizzati per questa camera.",
    masterSubApartment: "Neonati, bambini e capacità personalizzati per questo alloggio.",
    standardNote:
      "Comportamento standard: i neonati non incidono sulla capacità e non comportano alcun addebito.",
    capacityLabel: "Capacità",
    capacityGuestsNote:
      'ospite · impostato in "Capacità"; queste regole regolano solo chi viene conteggiato | ospiti · impostato in "Capacità"; queste regole regolano solo chi viene conteggiato',
    infantUpTo: "I neonati arrivano fino a",
    years: "anni",
    childToAdult: "Un bambino diventa adulto a",
    maxInfants: "Numero massimo di neonati",
    perBooking: "per prenotazione",
    infantsOccupy: "I neonati occupano un posto",
    infantsCharged: "I neonati comportano un addebito",
    childrenCount: "I bambini contano come ospite",
    ageLegend:
      "Neonato: meno di {infant} anni · Bambino: {infant}–{childTo} anni · Adulto: {adult}+ anni.",
    listingCapacity: "Capacità dell'annuncio",
    listingCapacityHint: 'Impostata in "Capacità" e condivisa con "Occupazione".',
    thisAccommodation: "Questo alloggio",
    loadError: "Impossibile caricare le regole per gli ospiti.",
    saveSuccess: "Regole per gli ospiti salvate con successo.",
    saveError: "Impossibile salvare le regole per gli ospiti.",
  },
  globalPayments: {
    title: "Pagamenti globali (Appartamenti/Ville)",
    pill: "Globale",
    desc: "Questa impostazione si applica a tutti gli alloggi appartamento/villa dell'utente.",
    loading: "Caricamento impostazioni…",
    paymentType: "Tipo di pagamento",
    onArrivalLabel: "Paga all'arrivo",
    onArrivalDesc: "L'ospite prenota e paga direttamente all'arrivo.",
    onlineLabel: "Pagamento online",
    onlineDesc: "L'ospite paga online al momento della prenotazione.",
    savedAtUserLevel: "Salvato a livello utente per appartamenti/ville.",
    globalDiscount: "Sconto globale",
    enableGlobalDiscount: "Attiva sconto globale",
    discountType: "Tipo di sconto",
    percentageLabel: "Percentuale",
    percentageDesc: "Sconto proporzionale al totale.",
    fixedLabel: "Fisso",
    fixedDesc: "Importo fisso da detrarre.",
    valueTitle: "Valore",
    phPercentage: "es. 10",
    phFixed: "es. 15.00",
    helpPercentage: "Fino al 100%. Applicato al totale.",
    helpFixed: "Viene detratto un importo fisso in {currency}.",
    previewTitle: "Anteprima",
    previewPercentage: "Verrà applicato uno sconto globale del {percent}%.",
    previewFixed: "Verrà applicato uno sconto globale di {amount}.",
    appliesAllDirect: "Si applica a tutte le prenotazioni dirette per appartamenti/ville.",
    saveSuccess: "Pagamenti globali salvati.",
    saveError: "Impossibile salvare i pagamenti globali.",
  },
  payments: {
    loading: "Caricamento impostazioni…",
    q02Title: "Quando paga l'ospite?",
    savingBadge: "Salvataggio…",
    payOnArrivalName: "Paga all'arrivo",
    payOnArrivalHint: "L'ospite prenota e paga direttamente all'arrivo.",
    payOnlineName: "Pagamento online",
    payOnlineHint: "L'ospite paga online al momento della prenotazione.",
    q03Title: "Tempo per pagare",
    onlineOnlyBadge: "Solo pagamento online",
    holdDesc:
      "Il calendario resta bloccato mentre l'ospite completa il pagamento.<br>Se non paga entro il tempo stabilito, <strong>la disponibilità viene rilasciata automaticamente</strong>.",
    unitMin: "min",
    unitHour: "ora",
    unitHours: "ore",
    q04Title: "Pagamento parziale",
    partialTitle: "Consenti di pagare solo una parte alla prenotazione",
    partialOnDesc:
      "<strong>Attivo.</strong> L'ospite può pagare il <strong>{percent}%</strong> ora e il resto prima dell'arrivo (oppure pagare l'intero importo).",
    partialOffDesc:
      "<strong>Disattivato.</strong> L'ospite paga l'<strong>intero importo</strong> alla prenotazione.",
    blockTitle: "Il resto si paga presso l'alloggio",
    blockOnDesc:
      "<strong>Attivo.</strong> L'ospite paga <strong>solo il {percent}%</strong> online; il resto viene saldato <strong>all'arrivo</strong> (non può pagare l'intero importo online).",
    blockOffDesc:
      "<strong>Disattivato.</strong> L'ospite può scegliere se pagare il {percent}% o l'intero importo online.",
    q05Title: "Promemoria saldo",
    reminderTitle: "Invia un promemoria per pagare il saldo residuo",
    reminderOnDesc:
      "<strong>Attivo.</strong> <strong>{when}</strong> dell'arrivo (intorno alle 09:00, ora dell'alloggio) all'ospite viene inviato un link per pagare il saldo residuo via <strong>WhatsApp ed email</strong>.",
    reminderOffDesc:
      "<strong>Disattivato.</strong> L'ospite non riceve un promemoria per pagare il saldo online prima dell'arrivo.",
    daysBefore: "{count} giorno prima | {count} giorni prima",
    reminderDaysLabel: "Giorni prima dell'arrivo",
    reminderHint:
      "Inviato una sola volta e solo agli ospiti con un saldo residuo. Se il resto viene pagato presso l'alloggio, non viene inviato.",
    approveTitle: "Approva le prenotazioni",
    approveCardTitle: "Approva ogni prenotazione prima della conferma",
    approveOnDesc:
      "<strong>Attivo.</strong> Ogni prenotazione resta <strong>in attesa della tua approvazione</strong>: ricevi una notifica e decidi se accettarla o rifiutarla. Non viene confermata finché non la approvi.",
    approveOffDesc:
      "<strong>Disattivato.</strong> Le prenotazioni <strong>si confermano automaticamente</strong> una volta completato il pagamento. Attivalo se preferisci esaminare e approvare personalmente ogni richiesta.",
    saveSuccess: "Salvato.",
    saveError: "Impossibile salvare le modifiche.",
  },
  unitConfig: {
    descByRoom: "Descrizione per camera",
    descByRoomHint:
      "Ogni camera ha la propria descrizione e la propria visibilità nella prenotazione diretta.",
    loadingRooms: "Caricamento camere…",
    emptyHotel: "Questo hotel non ha camere configurate.",
    visible: "Visibile",
    hidden: "Nascosta",
    roomDescPlaceholder: "Descrivi {name} (letti, servizi, viste…)",
    savingDesc: "Salvataggio…",
    autosaveHint: "Salvato automaticamente quando esci dal campo.",
    loadingProperty: "Caricamento dati dell'alloggio…",
    loadErrorProperty: "Impossibile caricare le impostazioni di questo alloggio.",
    amenitiesByRoom: "Servizi per camera",
    amenitiesByRoomHint:
      "Ogni camera può offrire servizi diversi. La prenotazione diretta e l'Agente IA utilizzano quelli della camera assegnata all'ospite.",
    amenitiesCount: "{count} servizio | {count} servizi",
    noAmenities: "Nessun servizio",
    titleDescription: "Descrizione dell'alloggio",
    titleServices: "Dotazioni e comfort",
    subtitleDescription:
      "Modifica la descrizione che gli ospiti vedranno nella tua pagina di prenotazione diretta.",
    subtitleServices: "Indica cosa offre questo alloggio e carica le foto.",
  },
};
